import { Pipe } from "ts-functionaltypes";

// for more information about `pipe` and `compose` see articles:
// https://medium.com/free-code-camp/pipe-and-compose-in-javascript-5b04004ac937
// https://medium.com/javascript-scene/reduce-composing-software-fe22f0c39a1d

/**
 * Processes an array of functions as a pipeline. 
 * This can be used to increase readability when needing to call multiple methods on an object.
 * 
 * @example 
 * pipe(
 *   (points: Data[]) => groupBy(points, item => item.year as number),
 *   (groups: Grouped<Data, number>[]) => groups.map(item => ...),
 *   (points: Data[]) => sortBy(points, point => point.year as number)
 * )(data);
 * 
 * @param fns Array of functions to pipe
 */
export const pipe: Pipe = (...fns) => x => fns.reduce((v, f) => f(v), x);

 
